import { useSelector } from "react-redux";
import { useMemo } from "react";

interface Carrera {
  descripcionCarrera: string;
  carreraDeGrado: boolean;
}

interface StudentState {
  carreraActual: string;
  listadoCarreras: Carrera[];
}

interface RootState {
  student: StudentState;
}

interface CarreraInfo {
  esCarreraDeGrado: boolean | null;
  carreraEncontrada: Carrera | null;
}

const useCarreraType = (): CarreraInfo => {
  const { carreraActual, listadoCarreras } = useSelector((state: RootState) => state.student);

  const carreraInfo = useMemo(() => {
    if (!carreraActual || !listadoCarreras?.length) {
      return {
        esCarreraDeGrado: null,
        carreraEncontrada: null,
      };
    }

    const carreraEncontrada = listadoCarreras.find((carrera: Carrera) => carrera.descripcionCarrera === carreraActual);

    return {
      esCarreraDeGrado: carreraEncontrada ? carreraEncontrada.carreraDeGrado : null,
      carreraEncontrada: carreraEncontrada || null,
    };
  }, [carreraActual, listadoCarreras]);

  return carreraInfo;
};

export default useCarreraType;
